import {Helmet} from "react-helmet-async";
import {Navigate} from "react-router";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {InvoiceDetails} from "@/pages/billing/invoices/InvoiceDetails.tsx";

export const InvoiceDetailsPage = () => {
  const {user} = useCurrentUserContext();
  if (user && !user?.has_admin_access) {
    return <Navigate to="/access-denied" />;
  }
  return (
    <ContentContainer title=" ">
      <Helmet>
        <title>Invoice Details</title>
      </Helmet>
      <UpErrorBoundary>
        <InvoiceDetails />
      </UpErrorBoundary>
    </ContentContainer>
  );
};
